export const videos = [
  {
    embedID: "vdiYtiKD8eI",
    title: "Some title",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus maiores earum quaerat, temporibus suscipit libero distinctio sequi consequatur quibusdam possimus repellendus excepturi atque ad? Dolore asperiores tempore aut dicta blanditiis.",
    suggested: [
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
    ],
  },
  {
    embedID: "OlhBL5_-nx4",
    title: "Some title",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus maiores earum quaerat, temporibus suscipit libero distinctio sequi consequatur quibusdam possimus repellendus excepturi atque ad? Dolore asperiores tempore aut dicta blanditiis.",
    suggested: [
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
    ],
  },
  {
    embedID: "vdiYtiKD8eI",
    title: "Some title",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus maiores earum quaerat, temporibus suscipit libero distinctio sequi consequatur quibusdam possimus repellendus excepturi atque ad? Dolore asperiores tempore aut dicta blanditiis.",
    suggested: [
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
    ],
  },
  {
    embedID: "vdiYtiKD8eI",
    title: "Some title",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus maiores earum quaerat, temporibus suscipit libero distinctio sequi consequatur quibusdam possimus repellendus excepturi atque ad? Dolore asperiores tempore aut dicta blanditiis.",
    suggested: [
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
      {
        url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      },
    ],
  },
];

export const categories = {
  mech: [
    {
      img: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      title: "dfsfe",
      href: "0",
    },
    {
      img: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      title: "Mechanical",
      href: "1",
    },
    {
      img: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      title: "Mechanical",
      href: "2",
    },
  ],
  phy: [
    {
      img: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      title: "Mechanical",
      href: "0",
    },
  ],
};

export const titles = { mech: "Mechanical", phy: "Physics" };

export const categoriesVideo = {
  mech: [
    {
      embedID: "b6SUbAkIAzY",
      thumbnail: "1jL_gv1bWcIlyH9UEljStaJqCuPtHqJ1G",
      href: "0",
      title: "Pneumatic reciprocating water pumping system",
      description:
        "Pneumatic resiprocating water pumping system is used to pump the water from one place to another place using Pneumatic operated cylinder",
      suggested: [
        {
          url: "1RsgucUrkvUK4Q1gGAyHVzISB-9SHAwqV",
          title: "High pressure pneumatic machine vice",
          href: "1",
        },
        {
          url: "1IFqx0XdctEHDpbMXN7BzLbCv6j2G1rwM",
          title: "Pneumatic solenoid operated grinding machine",
          href: "2",
        },
        {
          url: "1nMsBDFF4u_Pu5IWuhEvSgY_AVdBw0Zdb",
          title:
            "Auto indexing gear cutting attachment for pneumatic shaping machine",
          href: "3",
        },
        {
          url: "1_KO2Zu7ZwC1R9RFhLiJ0gFWFH0t6mxzt",
          title: "Hydraulic pipe bending machine mechanical project",
          href: "4",
        },
      ],
    },
    {
      embedID: "vSzC-1zdD0w",
      thumbnail: "1RsgucUrkvUK4Q1gGAyHVzISB-9SHAwqV",
      href: "1",
      title: "High pressure pneumatic machine vice",
      description:
        "High pressure pneumatic machine vice is used to hold the workpiece and it is operated  using pneumatic cylinder",
      suggested: [
        {
          url: "1IFqx0XdctEHDpbMXN7BzLbCv6j2G1rwM",
          title: "Pneumatic solenoid operated grinding machine",
          href: "2",
        },
        {
          url: "1nMsBDFF4u_Pu5IWuhEvSgY_AVdBw0Zdb",
          title:
            "Auto indexing gear cutting attachment for pneumatic shaping machine",
          href: "3",
        },
        {
          url: "1_KO2Zu7ZwC1R9RFhLiJ0gFWFH0t6mxzt",
          title: "Hydraulic pipe bending machine mechanical project",
          href: "4",
        },
        {
          url: "1_4yoQXCv0NTLcb2qstq_PUz5I02dsxHu",
          title: "Project on cold chamber die casting machine",
          href: "5",
        },
      ],
    },
    {
      embedID: "cCBomZPgnmM",
      thumbnail: "1IFqx0XdctEHDpbMXN7BzLbCv6j2G1rwM",
      href: "2",
      title: "Pneumatic solenoid operated grinding machine",
      description:
        "The pneumatic grinding is a metal grinding machine tool designed to grind metal by applying pneumatic pressure",
      suggested: [
        {
          url: "1nMsBDFF4u_Pu5IWuhEvSgY_AVdBw0Zdb",
          title:
            "Auto indexing gear cutting attachment for pneumatic shaping machine",
          href: "3",
        },
        {
          url: "1_KO2Zu7ZwC1R9RFhLiJ0gFWFH0t6mxzt",
          title: "Hydraulic pipe bending machine mechanical project",
          href: "4",
        },
        {
          url: "1_4yoQXCv0NTLcb2qstq_PUz5I02dsxHu",
          title: "Project on cold chamber die casting machine",
          href: "5",
        },
        {
          url: "1lH5_1kIUftS4sRPg4vcJ-xvmU6Vw_UdG",
          title: "CNC pneumatic auto feed punching machine",
          href: "6",
        },
      ],
    },
    {
      embedID: "Wg2LwKT16EU",
      thumbnail: "1nMsBDFF4u_Pu5IWuhEvSgY_AVdBw0Zdb",
      href: "3",
      title:
        "Auto indexing gear cutting attachment for pneumatic shaping machine",
      description:
        "This project intends to use pneumatic shaper for high production of automatic gear cutting with auto indexing work piece",
      suggested: [
        {
          url: "1_KO2Zu7ZwC1R9RFhLiJ0gFWFH0t6mxzt",
          title: "Hydraulic pipe bending machine mechanical project",
          href: "4",
        },
        {
          url: "1_4yoQXCv0NTLcb2qstq_PUz5I02dsxHu",
          title: "Project on cold chamber die casting machine",
          href: "5",
        },
        {
          url: "1lH5_1kIUftS4sRPg4vcJ-xvmU6Vw_UdG",
          title: "CNC pneumatic auto feed punching machine",
          href: "6",
        },
      ],
    },
    {
      embedID: "6PqGQWMQUKA",
      thumbnail: "1_KO2Zu7ZwC1R9RFhLiJ0gFWFH0t6mxzt",
      href: "4",
      title: "Hydraulic pipe bending machine mechanical project",
      description:
        "Hydraulic pipe benders are mechanisms that use hydraulic pressure to bend various sizes of metal pipe and electrical conduit to specific angles",
      suggested: [
        {
          url: "1_4yoQXCv0NTLcb2qstq_PUz5I02dsxHu",
          title: "Project on cold chamber die casting machine",
          href: "5",
        },
        {
          url: "1lH5_1kIUftS4sRPg4vcJ-xvmU6Vw_UdG",
          title: "CNC pneumatic auto feed punching machine",
          href: "6",
        },
        {
          url: "1KGyzf26Q4-CqfOcDVKrW0vkeiGScjexL",
          title: "Sliding ram by using quick return mechanism",
          href: "6",
        },
        {
          url: "1lSO2JnmA2wYZ439h2C_UWGXIfaHkF4x_",
          title: "Mini hydraulic press machine",
          href: "6",
        },
      ],
    },
  ],
  phy: [
    {
      embedID: "OlhBL5_-nx4",
      thumbnail:
        "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
      href: "0",
      title: "Some title",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus maiores earum quaerat, temporibus suscipit libero distinctio sequi consequatur quibusdam possimus repellendus excepturi atque ad? Dolore asperiores tempore aut dicta blanditiis.",
      suggested: [
        {
          url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
        },
        {
          url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
        },
        {
          url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
        },
        {
          url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
        },
        {
          url: "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp",
        },
      ],
    },
  ],
};
